import { render, staticRenderFns } from "./SpaceUsers.vue?vue&type=template&id=496ba304&"
import script from "./SpaceUsers.vue?vue&type=script&lang=js&"
export * from "./SpaceUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports